import { IFile } from '@repo/toolkit/types'

import { Files } from '../../../lib/constants/files'
import { FileType } from '../../../lib/types/models/file/file'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export type ProgramDocumentRequest = IFile & {
  centerId: number
}

export async function createCenterProgramDocument(input: ProgramDocumentRequest) {
  const { centerId, ...data } = input

  const file = await uploadFile(Files.CENTER_PROGRAM_DOCUMENT, data)
  if (!file) throw new Error('Failed to upload file')

  return restApiClient
    .url(constructApiUrl(API.centers.createCenterProgramDocument.url, { id: centerId }))
    .post<FileType, IFile>(file)
}
